import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const ServerPatchesPage = lazy(
  () => import('@/features/Servers/pages/ServerPatchesPage'),
)

export const Route = createFileRoute('/infra/servers/$id/')({
  beforeLoad: protectedRouteGuard,
  component: () => (
    <Suspense fallback={<Loading />}>
      <ServerPatchesPage />
    </Suspense>
  ),
})
